import React, { useRef, useState, useEffect } from "react";
import "./PlayerPage.scss";
import AmpleLogoAudio from "../../assets/images/player/ample-logo-audio.png";
import { FaPlay, FaPause, FaVolumeUp, FaVolumeMute } from 'react-icons/fa'; 

function getQueryParam(search, key) {
  const params = new URLSearchParams(search);
  return params.get(key);
}

const PlayerPage = (props) => {
  const songUrl =
    getQueryParam(props.location.search, "song_url") ||
    "https://ample-samples.s3.us-east-2.amazonaws.com/clear/request/songs/2025/09/12/88Y4H1Ie5JiBvFaFlBH4aRJEhpbH8Fty9Cuu58zx.mp3";

  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [volume, setVolume] = useState(1);
  const [isMuted, setIsMuted] = useState(false);

  useEffect(() => {
    const audio = audioRef.current;

    const setAudioData = () => {
      setDuration(audio.duration);
      setCurrentTime(audio.currentTime);
    };

    const updateTime = () => setCurrentTime(audio.currentTime);

    if (audio) {
      audio.addEventListener("loadedmetadata", setAudioData);
      audio.addEventListener("timeupdate", updateTime);
      audio.addEventListener("ended", () => setIsPlaying(false)); 
    }

    return () => {
      if (audio) {
        audio.removeEventListener("loadedmetadata", setAudioData);
        audio.removeEventListener("timeupdate", updateTime);
        audio.removeEventListener("ended", () => setIsPlaying(false));
      }
    };
  }, [isPlaying, songUrl]); 

  const formatTime = (time) => {
    if (isNaN(time)) return "00:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes < 10 ? "0" + minutes : minutes}:${
      seconds < 10 ? "0" + seconds : seconds
    }`;
  };

  const handlePlayPause = () => {
    const audio = audioRef.current;
    if (audio) {
      if (isPlaying) {
        audio.pause();
      } else {
        audio.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleProgressChange = (e) => {
    const audio = audioRef.current;
    if (audio) {
      audio.currentTime = e.target.value;
      setCurrentTime(e.target.value);
    }
  };

  const handleVolumeChange = (e) => {
    const audio = audioRef.current;
    if (audio) {
      audio.volume = e.target.value;
      setVolume(e.target.value);
      if (e.target.value > 0) {
        setIsMuted(false);
      } else {
        setIsMuted(true);
      }
    }
  };

  const handleToggleMute = () => {
    const audio = audioRef.current;
    if (audio) {
      audio.muted = !isMuted;
      setIsMuted(!isMuted);
      if (!isMuted && audio.volume === 0) {
        setVolume(1); 
        audio.volume = 1;
      }
    }
  };

  return (
    <div className="player-page">
      <div className="logo">
        <img src={AmpleLogoAudio} alt="Ample Logo Audio" />
      </div>
      <div className="audio-box custom-player">
        <audio ref={audioRef} src={songUrl} type="audio/mpeg" hidden /> 

        <div className="controls">
          <button className="play-pause-btn" onClick={handlePlayPause}>
            {isPlaying ? <FaPause size={18} /> : <FaPlay size={18} />}
          </button>
          <span className="current-time">{formatTime(currentTime)}</span>
          <input type="range" className="progress-bar" min="0" max={duration} value={currentTime} onChange={handleProgressChange} style={{background: `linear-gradient(to right, #e54f4c 0%, #e54f4c ${(currentTime / duration) * 100}%, #d1d1d1 ${(currentTime / duration) * 100}%, #d1d1d1 100%)`}}/>
          <span className="duration">{formatTime(duration)}</span>
          <button className="volume-btn" onClick={handleToggleMute}>
            {isMuted || volume === 0 ? <FaVolumeMute size={18} /> : <FaVolumeUp size={18} />}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PlayerPage;